import { render, staticRenderFns } from "./PressureWidget.vue?vue&type=template&id=db0947bc&scoped=true&"
import script from "./PressureWidget.vue?vue&type=script&lang=ts&"
export * from "./PressureWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0947bc",
  null
  
)

export default component.exports